import { render } from "./ManageColumns.vue?vue&type=template&id=63f9c6c8"
import script from "./ManageColumns.vue?vue&type=script&lang=js"
export * from "./ManageColumns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__